import {
	Normal,
	NormalWide,
	Actualite,
	ActualiteWide,
	Statistique,
	FichePratique,
} from './Base'

import Presse from './Presse'
import Dossier from './Dossier'
import Media from './Media'

export {
	Normal,
	NormalWide,
	Actualite,
	ActualiteWide,
	Dossier,
	Media,
	Presse,
	Statistique,
	FichePratique,
}



// WEBPACK FOOTER //
// ./js/website/react_components/teasers/index.js